import * as THREE from 'three';
import { CSS2DRenderer } from 'three/examples/jsm/renderers/CSS2DRenderer.js';
import { TrackballControls } from 'three/examples/jsm/controls/TrackballControls.js';
import ThreeGlobe from "three-globe";
import countries from "./globe-data-min.json";
/**
 * Base
 */

/**
 * Sizes
 */

const sizes = {
  width: window.innerWidth,
  height: window.innerHeight
};

// Canvas
const canvas = document.querySelector('canvas.webgl-2');

// Scene
const scene = new THREE.Scene();

const languages = [
  {
    name: 'JavaScript',
    color: '#f1e05a',
  },
  {
    name: 'TypeScript',
    color: '#3178c6',
  },
  {
    name: 'HTML',
    color: '#e34c26',
  },
  {
    name: 'CSS',
    color: '#563d7c',
  },
  {
    name: 'Python',
    color: '#3572A5',
  },
  {
    name: 'Three.js',
    color: '#f8ca00',
  },
  {
    name: 'React',
    color: '#61dafb',
  },
  {
    name: 'Node.js',
    color: '#4c9f38',
  },
  {
    name: 'Express',
    color: '#4c9f38',
  },
  {
    name: 'MongoDB',
    color: '#4c9f38',
  },
  {
    name: 'React Native',
    color: '#61dafb',
  },
  {
    name: 'TensorFlow',
    color: '#f8ca00',
  },
  {
    name: 'GraphQL',
    color: '#e10098',
  },
  {
    name: 'Vue',
    color: '#41b883',
  },
  {
    name: 'Motoko',
    color: '#fbb03b',
  },
  {
    name: 'Next.js',
    color: '#00ADD8',
  },
  {
    name: 'GLSL',
    color: '#5686a5',

  },
  {
    name: 'Redux',
    color: '#4c9f38',
  },
  {
    name: 'Docker',
    color: '#4c9f38',
  },
  {
    name: 'Scikit-Learn',
    color: '#4c9f38',
  }

];

const gData = languages.map(language => {
  const InnerHtml = `
<div style='display: flex; align-items: center; width: 100%; height: 100%; padding: 0px 12px;'>
    <div class='text-center' style='font-size: 0.8rem; color: #fff;'>
        ${language.name}
    </div>
    <div class='rounded-circle' style='background-color: ${language.color}; width: 4px; height: 4px; border-radius: 50%; margin-left:10px;'>
    </div>
</div>

`;
  return {
    lat: (Math.random() - 0.5) * 180,
    lng: (Math.random() - 0.5) * 360,
    html: InnerHtml
  };
});
const sect = document.getElementById('globe-sect');
const labelRenderer = new CSS2DRenderer();
labelRenderer.setSize(sizes.width, sizes.height);
// place renderer in sect
labelRenderer.domElement.style.position = 'absolute';
labelRenderer.domElement.style.top = '0px';
labelRenderer.domElement.style.pointerEvents = 'none';
sect.appendChild(labelRenderer.domElement);

const Globe = new ThreeGlobe({
})
  .htmlElementsData(gData)
  .htmlElement(d => {
    const el = document.createElement('div');
    el.innerHTML = d.html;
    el.style.color = '#fff';
    el.style.height = `40px`;
    el.style.backgroundColor = 'rgba(0,0,0,0.5)';
    el.style.borderRadius = '10%';
    el.style.backdropFilter = 'blur(10px)';
    return el;
  })
  .hexPolygonsData(countries.features)
  .hexPolygonResolution(3)
  .hexPolygonMargin(0.7)
  .showAtmosphere(true)
  .atmosphereColor("#3a228a")
  .atmosphereAltitude(0.25);

const globeMaterial = Globe.globeMaterial();
globeMaterial.color = new THREE.Color(0x3a228a);
globeMaterial.emissive = new THREE.Color(0x220038);
globeMaterial.emissiveIntensity = 0.1;
globeMaterial.shininess = 0.7;

scene.add(Globe);

window.addEventListener('resize', () => {
  // Update sizes
  sizes.width = window.innerWidth;
  sizes.height = window.innerHeight;

  // Update camera
  camera.aspect = sizes.width / sizes.height;
  camera.updateProjectionMatrix();

  // Update renderer
  renderer.setSize(sizes.width, sizes.height);
  renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
});

// Base camera
const camera = new THREE.PerspectiveCamera(50, sizes.width / sizes.height, 0.1, 1000);
// Add lights
scene.add(new THREE.AmbientLight(0xbbbbbb, 0.3));
var dLight = new THREE.DirectionalLight(0xffffff, 0.8);
dLight.position.set(-800, 2000, 400);
camera.add(dLight);

var dLight1 = new THREE.DirectionalLight(0x7982f6, 1);
dLight1.position.set(-200, 500, 200);
camera.add(dLight1);

var dLight2 = new THREE.PointLight(0x8566cc, 0.5);
dLight2.position.set(-200, 500, 200);
camera.add(dLight2);

if (window.innerWidth < 768) {
  camera.position.z = 500;

} else {
  camera.position.z = 300;

}
camera.position.x = 0;
camera.position.y = 0;

scene.add(camera);

/**
 * Renderer
 */
const renderer = new THREE.WebGLRenderer({
  canvas: canvas
});
renderer.setSize(sizes.width, sizes.height);
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
renderer.setClearColor(0x050D20, 1);

// Add camera controls
const tbControls = new TrackballControls(camera, renderer.domElement);
tbControls.minDistance = 101;
tbControls.rotateSpeed = 10;
tbControls.noZoom = true;
// tbControls.enablePan = false;
// Update pov when camera moves
Globe.setPointOfView(camera.position, Globe.position);
tbControls.addEventListener('change', () => Globe.setPointOfView(camera.position, Globe.position));
/**
 * Animate
 */
const clock = new THREE.Clock();

const tick = () => {

  tbControls.update();

  // Get elapsedtime
  const elapsedTime = clock.getElapsedTime();

  // Render
  renderer.render(scene, camera);
  labelRenderer.render(scene, camera);

  // Call tick again on the next frame
  window.requestAnimationFrame(tick);
};

tick();